// extracted by mini-css-extract-plugin
module.exports = {"hoursInfo":"styles_hoursInfo__H6G9-","hoursPerDay":"styles_hoursPerDay__3rlfG","hoursPerDayText":"styles_hoursPerDayText__21Mb1"};